import React from "react";

/**
 * 상세/등록 2열 — 3열(2fr·2fr·1fr)에서 1+2열 합(4fr) | 파일(1fr)
 */
export function ContentDetailTwoColLayout({main, aside, className = ""}) {
    return (
        <div className={`detail-list-panel-grid-main-file detail-list-v2-stack ${className}`.trim()}>
            <div className="detail-list-col">
                <div className="detail-list-col-scroll">{main}</div>
            </div>
            <div className="detail-list-col detail-list-col--memo">
                <div className="detail-list-col-scroll">{aside}</div>
            </div>
        </div>
    );
}
